<template>
	<div class="share-betslip">
		<div class="share-betslip__closed">
			<b-button
				class="share-betslip__closed__button betslip__details__button button"
				:class="{
					'no-bg': type != 'fill',
					disabled: disabled,
					full: type == 'full',
				}"
				@click="shareBet($event)"
				:disabled="disabled"
				:loading="sharingBet"
			>
				<span
					v-show="!sharingBet"
					class="share-betslip__closed__button__title"
					>{{ shareButtonText }}</span
				>
			</b-button>
		</div>

		<bottom-sheet
			v-if="shareCode && canShowBottomSheet"
			@has-mounted="showBottomSheet"
			@close="closeBottomSheet"
			ref="bottomSheet"
		>
			<div class="share-betslip__open">
				<social-links
					class="share-betslip__socials"
					:social-urls="socialUrls"
				/>
				<b-input
					class="share-betslip__input"
					type="text"
					name="sharing-code"
					readonly
					:value="shareLink"
				/>
				<b-input
					v-if="env.betSharingCode"
					class="share-betslip__input"
					type="text"
					name="sharing-code"
					readonly
					:value="!env.betSharingCode ? shareLink : shareCode"
				/>

				<b-button
					v-if="env.betSharingCode"
					class="share-betslip__button button button__primary full"
					@click="copyCodeToClipboard(true)"
					style="margin-bottom: 5%"
				>
					{{ $t("general.copy-code") }}
				</b-button>
				<b-button
					class="share-betslip__button button button__primary full"
					@click="copyCodeToClipboard(false)"
				>
					{{ $t("general.copy-link") }}
				</b-button>
			</div>
			<b-button class="button full no-bg" @click="closeBottomSheet">{{
				$t("general.cancel")
			}}</b-button>
		</bottom-sheet>
	</div>
</template>
<script>
import SocialLinks from "./SocialLinks.vue";
export default {
	name: "ShareBetslip",
	components: { SocialLinks },
	props: {
		shareButtonText: {
			type: String,
			default: "Share",
			required: false,
		},
		productType: {
			type: String,
			required: true,
		},
		bets: {
			type: Array,
			default: () => [],
		},
		betId: {
			type: String || Number,
			default: null,
		},
		profileId: {
			type: String || Number,
			default: null,
		},
		token: {
			type: String,
			default: null,
		},
		type: {
			type: String,
			default: "line",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			canShowBottomSheet: false,
			sharingBet: false,
			changedMatches: [],
			shareCode: null,
			socialUrls: null,
		};
	},
	mounted() {
		this.$emit("mounted");
	},
	methods: {
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		copyCodeToClipboard(copyCode) {
			this.$copyText(copyCode ? this.shareCode : this.socialUrls.copy).then(
				(e) => {
					this.$notifications.add({
						message: copyCode
							? this.$t("betslip.copied-the-code-successfully")
							: this.$t("betslip.copied-the-link-successfully"),
						title: this.$t("session.success"),
						type: "success",
						duration: 5000,
					});
				},
				(e) => {
					this.$notifications.add({
						message: this.$t("betslip.unable-to-copy-please-try-again"),
						title: this.$t("betslip.failed"),
						type: "error",
						duration: 5000,
					});
				}
			);
			this.analyticsTrack("general", "shareABet", {
				platform: "Link",
			});
		},
		shareBet(e) {
			if (this.sharingBet || this.disabled) return;
			let vm = this;
			let bets = vm.bets;
			vm.sharingBet = true;

			if (bets.length == 0 && !vm.betId) {
				vm.sharingBet = false;
				return;
			}

			// Map betslip to endpoint requirements
			let betslip = this.bets.map((bet) => {
				return {
					odd_key: bet.odd.odd_key,
					outcome_id: bet.odd.outcome_id || 0,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.parent_match_id || "",
					sub_type_id: bet.sub_type_id,
					has_parent: bet.is_shared || null,
					parent_code: bet.share_code || null,
				};
			});

			// Build payload
			let payload = {
				profile_id: vm.profileId,
				bet_id: vm.betId,
				token: vm.token,
				src: "MOBILE_WEB",
				product_type: vm.productType,
				betslip: betslip,
			};

			this.analyticsTrack("general", "shareABet", {
				betslip: payload.betslip,
				product_type: payload.product_type,
				src: payload.src,
			});

			this.$axios
				.post(`${BASE_V2_URL}share/encode`, payload)
				.then((response) => {
					vm.shareCode = response.data.code;
					vm.shareLink = response.data.link;
					vm.socialUrls = response.data.meta.social_urls;
					vm.sharingBet = false;
					vm.$nextTick(() => {
						vm.canShowBottomSheet = true;
					});
				})
				.catch((error) => {
					vm.placeBetButton = this.$t("betslip.share-betslip");
					vm.sharingBet = false;
					let errorMessage = this.$t(
						"session.an-error-occured-please-try-again"
					);
					if (error.response) errorMessage = error.response.data.message;

					vm.$notifications.add({
						message: errorMessage,
						title: this.$t("betslip.failed-to-share-betslip"),
						type: "error",
						duration: 5000,
					});
				});
		},
	},
};
</script>
<style lang="scss">
.share-betslip {
	&__closed {
		&__button {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			background: none;
			border: none;
			border-radius: 4px;
			padding: 8px;
			font-size: var(--font-small);
			margin-right: 5px;
			color: var(--always-white) !important;
			&__icon {
				margin-right: 3px;
				fill: var(--always-white);
			}
			&__title {
				font-weight: var(--font-weight-medium);
			}

			&.disabled {
				pointer-events: none;
				border: none;
				color: var(--light-gray) !important;
				.share-betslip__closed__button__icon path {
					fill: var(--light-gray) !important;
				}
				box-shadow: none;
			}
		}
	}
	&__open {
		padding: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.modal {
		&--active {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&__container {
			display: flex;
			flex-direction: column;
			align-items: center;
			border-radius: 4px;
			padding: 16px 10px;
			max-width: 768px;
			&-links {
				margin-bottom: 10px;
			}
		}
	}
	.input-sharing-code {
		background-color: var(--light-gray);
		border: 1px solid var(--light-gray);
		color: var(--black);
		text-align: center;
		margin-bottom: 10px;
		width: 80%;
		font-size: var(--font-large);
	}

	.copy-button {
		width: 100%;
		background-color: var(--yellow);
		border: none;
		font-weight: var(--font-weight-medium);
		text-transform: uppercase;
		color: var(--black);
		border-radius: 4px;
		padding: 8px 16px;
		font-size: var(--font-medium);
	}
	&__socials {
		margin-bottom: 10px;
	}
	&__input {
		margin-bottom: 10px;
		width: 100%;
		input {
			font-size: var(--font-small) !important;
			text-align: center;
		}
	}
}
</style>
